export function safeParseJSON(str: string): Record<string, any> | null {
    try {
        return JSON.parse(str);
    } catch (err: any) {
        return null;
    }
}
